import AsyncStorage from "@react-native-async-storage/async-storage";
const read = async (key) => {
    const value = await AsyncStorage.getItem(key);
    return value ? JSON.parse(value) : undefined;
};
const write = async (key, value) => AsyncStorage.setItem(key, JSON.stringify(value));
export { write, read };
